import { Box, Stack } from '@mantine/core'
import { getFormattedDateRange, MaintenanceTask, SeasonData } from './utils'
import { SeasonHeader } from './SeasonHeader'
import { TaskCard } from './TaskCard'

interface SeasonCardProps {
  season: SeasonData
  onTaskClick: (task: MaintenanceTask) => void
  onAddTask: () => void
  onPrevious?: () => void
  onNext?: () => void
  hasPackage: boolean
}

export function SeasonCard({
  season,
  onTaskClick,
  onAddTask,
  onPrevious,
  onNext,
  hasPackage,
}: SeasonCardProps) {
  const totalOwnTasks = season.tasks.length
  const completedOwnTasks = season.tasks.filter((t) => t.completed).length
  const totalRecommendedTasks = season.recommendedTasks.length
  const completedRecommendedTasks = season.recommendedTasks.filter(
    (t) => t.completed,
  ).length
  const totalMarkkuTasks = season.markkuTasks.length
  const completedMarkkuTasks = season.markkuTasks.filter(
    (t) => t.completed,
  ).length

  return (
    <Box
      style={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <SeasonHeader
        backgroundImage={season.backgroundImage}
        title={season.finnishName}
        dateRange={getFormattedDateRange(season.season, season.year)}
        totalCost={season.totalCost}
        onPrevious={onPrevious}
        onNext={onNext}
      />

      <Stack style={{ flex: 1 }}>
        <TaskCard
          title="Omat tehtävät"
          tasks={season.tasks}
          completedCount={completedOwnTasks}
          totalCount={totalOwnTasks}
          taskType="user"
          onTaskClick={onTaskClick}
          onAddTask={onAddTask}
          emptyMessage="Ei omia tehtäviä tälle kaudelle"
        />

        {totalRecommendedTasks > 0 && (
          <TaskCard
            title="Suositellut tehtävät"
            tasks={season.recommendedTasks}
            completedCount={completedRecommendedTasks}
            totalCount={totalRecommendedTasks}
            taskType="user"
            onTaskClick={onTaskClick}
            emptyMessage="Ei suositeltuja tehtäviä tälle kaudelle"
          />
        )}

        {hasPackage && (
          <TaskCard
            title="Markku hoitaa"
            tasks={season.markkuTasks}
            completedCount={completedMarkkuTasks}
            totalCount={totalMarkkuTasks}
            taskType="markku"
            onTaskClick={onTaskClick}
            emptyMessage="Ei Markun tehtäviä tälle kaudelle"
          />
        )}
      </Stack>
    </Box>
  )
}
